// 品牌配色单一源(2026-06-09 review 收口)。
// 背景:后端 GET /tenant/brand-assets 对未配置品牌的租户返回 colors:null(C-drift),
// 前端多处直接读 colors.primary / Object.values(colors) 会崩。统一在此兜底,各消费方调
// resolveBrandColors() 做渲染兜底;数据层(draft/save)保持原始 null 不污染后端。
// 位置在 lib/(基础层)——components/poster 与 features/brand-assets 都能 import 且不违反 FSD 单向。
export interface BrandColorPalette {
  primary: string;
  secondary: string;
  accent: string;
}

// 统一默认配色 = BrandAssetsEditor「恢复默认」的青紫系(此前 BrandAssetsPage/Preview 各自硬编码蓝灰系,不一致)。
export const DEFAULT_BRAND_COLORS: BrandColorPalette = {
  primary: "#22d3ee",
  secondary: "#5b21b6",
  accent: "#fbbf24",
};

// 渲染兜底:colors 为 null/undefined 时返回默认配色(同一常量引用,便于 save 时判「未改」)。
export function resolveBrandColors(
  colors: BrandColorPalette | null | undefined
): BrandColorPalette {
  return colors ?? DEFAULT_BRAND_COLORS;
}
